var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publication-manager"
  }, [(_vm.hasControls && _vm.hasPublications) ? _c('common-button', {
    staticClass: "uk-margin",
    attrs: {
      "icon": "plus",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.newPublication
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('actions.addPublication')) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('publication-form', {
    ref: "formModal",
    attrs: {
      "values": _vm.editedPublication,
      "publications": _vm.publications
    },
    on: {
      "submit": _vm.submitPublication,
      "hidden": _vm.resetEditedPublication
    }
  }), _vm._v(" "), (_vm.hasPublications) ? _c('publication-table', {
    attrs: {
      "publications": _vm.publications,
      "show-actions": _vm.showTableActions
    },
    on: {
      "edit": _vm.editPublication,
      "remove": _vm.removePublication
    }
  }) : _c('div', {
    staticClass: "uk-placeholder uk-margin-remove-top uk-text-center"
  }, [_c('div', [_c('icon', {
    attrs: {
      "name": "warning"
    }
  }), _vm._v("\n      " + _vm._s(_vm.$t('hints.noPublications')) + "\n    ")], 1), _vm._v(" "), (_vm.hasControls) ? _c('common-button', {
    staticClass: "uk-margin",
    attrs: {
      "icon": "plus",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.newPublication
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('actions.addPublication')) + "\n    ")]) : _vm._e()], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05ed3b9c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/PublicationManager.vue
// module id = 1838
// module chunks = 0